














































import { computed, defineComponent, PropType, toRef } from "@vue/composition-api";
import { ContentSet } from "@scrile/api-provider/dist/api/ContentSetProvider";
import { ContentFeed, ContentFeedTypeEnum } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { checkAuthorities } from "@scrile/tools/dist/lib/SecurityHelpers";
import useFeedCoverIcons from "@/hooks/useFeedCoverIcons";
import { getFilesIcon, isMediaFile, isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import BaseChip from "@/components/BaseChip";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import ContentCover from "@/components/ContentCover";
import ContentFeedCoverAuthor from "./components/ContentFeedCoverAuthor";
import ContentFeedCoverGradient from "./components/ContentFeedCoverGradient";

function isContentFeed(f: ContentFeed | ContentSet): f is ContentFeed {
  return "files" in f;
}
export default defineComponent({
  name: "ContentFeedCover",
  components: { ContentFeedCoverGradient, ContentFeedCoverAuthor, BaseChip, BaseIcon, ContentCover, BaseImage },
  props: {
    postData: { type: Object as PropType<ContentFeed | ContentSet>, required: true },
    small: { type: Boolean, default: false },
    hideIcon: { type: Boolean, default: false },
    authUserId: { type: String, default: "" },
    currentAuthorities: { type: Array as PropType<string[]>, default: () => [] },
    withProportion: { type: Boolean, default: false },
    withAuthor: { type: Boolean, default: false },
  },
  setup(props) {
    const user = computed(() => (isContentFeed(props.postData) ? props.postData.user : null));
    const coverFile = computed(() =>
      isContentFeed(props.postData) ? props.postData.files.find(f => isMediaFile(f)) : props.postData.cover
    );
    const method = computed(
      () => (coverFile.value && isVideoFile(coverFile.value) && "getVideoThumbnail") || "getImageThumbnail"
    );
    const coverSrc = computed(() =>
      !coverFile.value ? "" : MediaFilesController[method.value](coverFile.value.urlPart, "480p")
    );

    const {
      isAuthor,
      showErrorIcon,
      showProcessingIcon,
      showScheduledIcon,
      scheduledText,
      showGradient,
    } = useFeedCoverIcons(toRef(props, "authUserId"), toRef(props, "postData"));

    const icon = computed(() =>
      props.postData.type === ContentFeedTypeEnum.EVENT
        ? "sci-calendar"
        : props.postData.type === ContentFeedTypeEnum.MEDIA && isContentFeed(props.postData)
        ? getFilesIcon(props.postData.files)
        : "sci-file-multiple"
    );

    const showCenterIcon = computed(() => isContentFeed(props.postData) && !props.postData.purchased);

    const mainIcon = computed(() => {
      if (showProcessingIcon.value) return "sci-processing";
      if (showScheduledIcon.value) return "sci-watch";
      return "sci-eye-off";
    });

    const showLocked = computed(() =>
      isContentFeed(props.postData) &&
      checkAuthorities(props.currentAuthorities, isAuthor ? ["updateMyContentSet"] : ["updateAnyContentSet"])
        ? props.postData.subscriptionLevelId !== "0" || props.postData.pricePackageId !== "0"
        : false
    );

    const proportion = computed(() => {
      return coverFile.value && coverFile.value.width && coverFile.value.height
        ? Math.ceil((coverFile.value.height / coverFile.value.width) * 100)
        : 100;
    });

    const styles = computed(() =>
      props.withProportion
        ? {
            "padding-bottom": `${proportion}%`,
            "grid-row": `span ${Math.floor(proportion.value / 10)}`,
          }
        : {}
    );

    return {
      user,
      showErrorIcon,
      showProcessingIcon,
      showLocked,
      showGradient,
      showScheduledIcon,
      showCenterIcon,
      coverSrc,
      icon,
      mainIcon,
      scheduledText,
      styles,
    };
  },
});
